// src/hooks/useToast.js
import { useState, useRef, useCallback } from 'react';

export function useToast() {
  const [toast, setToast] = useState({ msg: '', show: false, type: 'success' });
  const timerRef = useRef(null);

  const showToast = useCallback((msg, type = 'success') => {
    setToast({ msg, show: true, type });
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setToast(t => ({ ...t, show: false })), 2800);
  }, []);

  return { toast, showToast };
}
